/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["articles-order-select{display:inline-block;width:100%}articles-order-select>.input-container{max-width:100%}"];
export { styles as styles };
